'use client';
import { NavigateOptions } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useMemo, useState } from 'react';

import { readParams } from '@/components/shared/helpers';

export function useClientFilterParams() {
  const searchParams = useSearchParams();
  const params = new URLSearchParams(searchParams);
  const pathname = usePathname();
  const { replace } = useRouter();
  const updateParams = (
    key: string,
    value: any,
    forceSetFalse: boolean = false,
    options?: NavigateOptions,
  ) => {
    if (
      value === true ||
      value.length > 0 ||
      value > 0 ||
      (forceSetFalse && value === false)
    ) {
      params.set(key, JSON.stringify(value));
    } else {
      params.delete(key);
    }
    if (forceSetFalse && value === true) {
      params.delete(key);
    }
    replace(`${pathname}?${params.toString()}`, options);
  };

  const clearParams = (options?: NavigateOptions) => {
    replace(`${pathname}`, options);
  };

  const filterParams = useMemo(() => readParams(params), [searchParams]); //readParams(params); //

  return { updateParams, clearParams, filterParams };
}

export function useFilterParams({ searchParams = {} }) {
  const params = new URLSearchParams(searchParams);
  const { push} = useRouter();
  const [resetParams,setResetParams] = useState(false)

  const updateParams = (
    key: string,
    value: any,
    forceSetFalse: boolean = false,
    options?: NavigateOptions,
  ) => {
    if (
      value === true ||
      value.length > 0 ||
      value > 0 ||
      (forceSetFalse && value === false)
    ) {
      params.set(key, JSON.stringify(value));
    } else {
      params.delete(key);
    }
    if (forceSetFalse && value === true) {
      params.delete(key);
    }
    push(`?${params.toString()}`, options);
  };

  const clearParams = (options?: NavigateOptions) => {
    setResetParams(true)
    push(`?`, options);
  };

  return { updateParams, clearParams ,resetParams};
}
